import React, { useEffect } from 'react';

const GoogleTagManager = () => {
  useEffect(() => {
    // Create and insert the script at the top of the <head>
    const scriptTag = document.createElement('script');
    scriptTag.innerHTML = `
      (function(w,d,s,l,i){
        w[l]=w[l]||[];
        w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
        var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
        j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-WVTQNFR8');
    `;
    document.head.insertBefore(scriptTag, document.head.firstChild);

    // Add <noscript> tag to the body
    const noscriptTag = document.createElement('noscript');
    noscriptTag.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WVTQNFR8"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.insertBefore(noscriptTag, document.body.firstChild);

    return () => {
      document.head.removeChild(scriptTag);
      document.body.removeChild(noscriptTag);
    };
  }, []);

  return null; // No need to return any JSX as everything is injected dynamically
};

export default GoogleTagManager;
